import React from "react";
import { Users, Share2, CreditCard } from "lucide-react";
import "./component.css";

const HealthRecordsSection = () => {
  return (
    <section className="health-records-section section">
      <div className="container">
        <div className="health-records-content">
          <div className="health-records-info">
            <h2 className="section-title">Manage Personal Health Records</h2>
            <p className="section-subtitle">
              ABHA, a part of ABDM, otherwise known as the National Digital
              Health Mission, is formulated to provide assistance for the
              integration of digital health infrastructure in India.
            </p>

            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">
                  <Users size={32} />
                </div>
                <h3 className="feature-title">Who can apply</h3>
                <p className="feature-description">
                  Anyone who is a valid citizen of India can create their ABHA
                  Address.
                </p>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <Share2 size={32} />
                </div>
                <h3 className="feature-title">How does it work</h3>
                <p className="feature-description">
                  Allow doctors to access your medical files, treatment history,
                  and diagnostic reports in one place.
                </p>
              </div>
            </div>

            <button
              className="btn btn-primary"
              onClick={() =>
                window.scrollTo({
                  top: 400,
                  behavior: "smooth",
                })
              }
            >
              <CreditCard size={24} />
              CREATE ABHA Address
            </button>
          </div>

          <div className="health-records-image">
            <img
              src="https://uat-cdn.drlallab.com/2023-06/create-abha.webp"
              alt="ABHA Creation Process"
              className="mobile-mockup"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HealthRecordsSection;
